import { palette } from '../../styles/tokens';

interface TodayPillProps {
  onClick: () => void;
}

export function TodayPill({ onClick }: TodayPillProps) {
  return (
    <button
      onClick={onClick}
      style={{
        padding: '5px 12px',
        borderRadius: 999,
        border: `1px solid ${palette.g200}`,
        background: palette.white,
        fontSize: 12,
        fontWeight: 600,
        color: palette.g700,
        cursor: 'pointer',
        fontFamily: 'inherit',
      }}
    >
      Today
    </button>
  );
}
